export Checkbox from './Checkbox'

export default from './Checkbox'



// WEBPACK FOOTER //
// ./src/Checkbox/index.js